import InvoiceIndex from '@/views/fmwebapp/invoices/Index'
import InvoiceRecognitionIndex from '@/views/fm/management/invoicerecognition/Index'
import InvoiceRecognitionDetail from '@/views/fm/management/invoicerecognition/InvoiceRecognitionDetail'

export default
[
    {
        name:`fmmodule:index`,
        path:`/fmmodule`,
        component: {
            template: '<div><router-view /></div>'
        },
        children: [           
            {
                name: `invoices:index`,
                path: `invoices`,
                component: InvoiceIndex
            },
            {
                name: `invoicerecognitiondata:index`,
                path: `invoicerecognition`,
                component: InvoiceRecognitionIndex,
                
            },
            {
                name: `invoicerecognitiondata:detail`,
                path: `invoicerecognition/:documentId`,
                component: InvoiceRecognitionDetail
            }  
        ]
    }
]